import { TreeViewResponseItem } from "@/apis/preview/v2/types";

import { getHighlightId } from "@/hooks/use-cell-highlight";
import { cn } from "@/lib/utils";
import { TagType } from "@/types/mapping";
import TreeTagItem from "./tree-tag-item";

export const ContainerHeader = (props: {
  treeViewItems: TreeViewResponseItem[];
  roleKey: string;
  selectedId?: string | null;
  onItemClick?: (tagKey: string, tagKoLabel: string) => void;
  onItemHoverStart?: (tagKey: string, tagKoLabel: string) => void;
  onItemHoverEnd?: () => void;
  /** 매핑탭 전용. tagKey 가 붙은 셀 수 — 0 이면 휴지통을 숨긴다. */
  getTaggedCellCount?: (tagKey: string) => number;
  onItemRemove?: (item: TreeViewResponseItem, cellCount: number) => void;
  /** 매핑탭 전용. 주어지면 헤더 행 hover 시 태그 상세정보 팝오버를 띄운다. */
  tagDetailRoleKey?: string;
  [any: string]: any;
}): React.ReactElement | null => {
  const {
    treeViewItems,
    roleKey,
    selectedId,
    onItemClick,
    onItemHoverStart,
    onItemHoverEnd,
    getTaggedCellCount,
    onItemRemove,
    tagDetailRoleKey,
    ...rest
  } = props;
  const getDepth = (tagType: TagType) => {
    switch (tagType) {
      case "ABSTRACT":
        return 0;
      case "LINE_ITEMS":
        return 1;
      case "AXIS":
        return 0;
      case "LINE_ITEM":
        return 0;
      case "MEMBER":
        return 1;
      case "TEXTBLOCK":
        return 0;
      default:
        return 0;
    }
  };
  return (
    <>
      <div
        className="flex flex-col p-[12px] items-end border rounded-md bg-slate-50 border-slate-200 w-[436px]"
        {...rest?.attributes}
        {...rest?.listeners}
      >
        {treeViewItems.map((item, index) => {
          // 헤더 행 중 셀에 실제로 붙는 태그. AXIS 차원의 도메인(*Domain)도 MEMBER 로 내려온다.
          const cellTaggable =
            item.tagType === "MEMBER" || item.tagType === "LINE_ITEM";
          const taggedCellCount =
            cellTaggable && getTaggedCellCount
              ? getTaggedCellCount(item.tagKey)
              : 0;
          return (
            <div
              key={`header-${item.id}`}
              className={cn("flex gap-2 items-center justify-start w-full", {
                "pl-[16px]": getDepth(item.tagType as TagType) > 0,
              })}
            >
              <TreeTagItem
                item={item}
                colored={false}
                depth={getDepth(item.tagType as TagType)}
                isSelected={
                  selectedId ===
                  getHighlightId(roleKey, item.tagKey, item.tagKoLabel)
                }
                onClick={
                  onItemClick && cellTaggable
                    ? () => onItemClick(item.tagKey, item.tagKoLabel)
                    : undefined
                }
                onHoverStart={
                  onItemHoverStart && cellTaggable
                    ? () => onItemHoverStart(item.tagKey, item.tagKoLabel)
                    : undefined
                }
                onHoverEnd={cellTaggable ? onItemHoverEnd : undefined}
                onRemove={
                  onItemRemove && taggedCellCount > 0
                    ? () => onItemRemove(item, taggedCellCount)
                    : undefined
                }
                tagDetailRoleKey={tagDetailRoleKey}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
